var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCreditCardExclamation = function SvgCreditCardExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3A1.5 1.5 0 0 0 0 4.5v1a.5.5 0 0 0 .5.5h19a.5.5 0 0 0 .5-.5v-1A1.5 1.5 0 0 0 18.5 3h-17zM.5 8a.5.5 0 0 0-.5.5v7A1.5 1.5 0 0 0 1.5 17h8.189A6 6 0 0 1 20 11.531V8.5a.5.5 0 0 0-.5-.5H.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 15.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0zm-4.593.444-.296-3.556h1.778l-.296 3.556h-1.186zm.593.889a.889.889 0 1 0 0 1.778.889.889 0 0 0 0-1.778z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgCreditCardExclamation;